/**
 * @generated SignedSource<<5d6bae1c0ff9d268af457c9ff7767978>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SupportingDocumentType = "pdf" | "http" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SupportingDocumentListItem_supportingDocument$data = {
  readonly filename: string;
  readonly type: SupportingDocumentType;
  readonly title: string;
  readonly uri: string;
  readonly " $fragmentType": "SupportingDocumentListItem_supportingDocument";
};
export type SupportingDocumentListItem_supportingDocument$key = {
  readonly " $data"?: SupportingDocumentListItem_supportingDocument$data;
  readonly " $fragmentSpreads": FragmentRefs<"SupportingDocumentListItem_supportingDocument">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SupportingDocumentListItem_supportingDocument",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uri",
      "storageKey": null
    }
  ],
  "type": "SupportingDocument",
  "abstractKey": null
};

(node as any).hash = "db658eb360f765bc42026e999122b4ed";

export default node;
